// Sector labels and tag tones of the temp worker app (constants/sectors.js, theme sector colors).

const SECTORS = {
    vente: "Vente",
    restauration: "Restauration",
    logistique: "Logistique",
    "grande distribution": "Grande distribution",
    administration: "Administration",
    industrie: "Industrie",
    autre: "Autre",
};

const ALIASES = {
    sale: "vente",
    food: "restauration",
    foods: "restauration",
    logistic: "logistique",
    largedistribution: "grande distribution",
    largedistributions: "grande distribution",
    industry: "industrie",
    other: "autre",
    "commerce, vente et grande distribution": "vente",
};

const TONES = {
    vente: { fg: "#0d47a1", bg: "#d4e5ff" },
    "grande distribution": { fg: "#2e7d32", bg: "#dff7df" },
    logistique: { fg: "#7b1fa2", bg: "#efd5f9" },
    restauration: { fg: "#e65100", bg: "#ffeacc" },
    administration: { fg: "#c2185b", bg: "#ffd6e7" },
    industrie: { fg: "#303f9f", bg: "#d9ddff" },
    bâtiment: { fg: "#5d4037", bg: "#e7ddd0" },
    transport: { fg: "#455a64", bg: "#dde7ec" },
    santé: { fg: "#00838f", bg: "#cff4f9" },
    éducation: { fg: "#00695c", bg: "#cfefe9" },
};

const OTHER_TONE = { fg: "#616161", bg: "#eeeeee" };

export const sectorLabel = (activity) => {
    const key = String(activity ?? "").trim().toLowerCase();
    return SECTORS[ALIASES[key] ?? key] ?? String(activity ?? "").trim();
};

export const sectorTone = (activity) => TONES[sectorLabel(activity).toLowerCase()] ?? OTHER_TONE;
